export const ms = {
    'buttons': {
        'return': 'Kembali'
    },
    'selects': {
        'currency': {
            'label': 'Mata Wang',
            'placeholder': 'Pilih mata wang',
            'options-title': 'Senarai syiling yang tersedia'
        },
        'currency-and-network': {
            'placeholder': 'Pilih mata wang dan rangkaian',
            'options-title': 'Senarai syiling yang tersedia'
        },
        'selected-label': 'Dipilih: {selected} daripada {length}',
        'search': 'Cari',
        'errors': {
            'invalid': 'Nilai tidak sah',
            'required': 'Diperlukan',
            'card-holder': 'Masukkan nama pertama dan terakhir pemegang kad',
            'input-amount': 'Masukkan jumlah',
            'fill-card': 'Isi butiran kad'
        },
        'empty-list': 'Senarai kosong',
        'address': {
            'label': 'Alamat pengeluaran dalam {currency}',
            'options-title': 'Senarai alamat yang tersedia'
        },
        'cardholder-input': {
            'placeholder': 'Pemegang Kad'
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'Alamat anda untuk deposit'
            },
            'invoice': {
                'address': 'Alamat',
                'paid-amount': 'Jumlah yang dibayar'
            }
        }
    },
    'labels': {
        'deposit': 'Deposit',
        'withdraw': 'Pengeluaran',
        'currency': 'Mata Wang',
        'amount': 'Jumlah',
        'invoice': {
            'remaining-time': 'Masa yang tinggal untuk membayar',
            'status': {
                'expires': 'Masa telah tamat',
                'success': 'Bayaran Berjaya',
                'error': 'Ralat'
            },
            'partially-paid': {
                'title': 'Dibayar sebahagian',
                'info': 'Jumlah telah dibayar sebahagian. Jumlah baki mesti dibayar untuk pembayaran berjaya.'
            },
            'orphan': {
                'title': 'Transaksi yatim',
                'description': 'Salah satu transaksi pada pesanan ini mengandungi rangkaian atau mata wang yang salah.',
                'contact': 'Hubungi sokongan teknikal dengan ID: '
            },
            'you-paid': 'Anda telah membayar',
            'active-order': 'Pesanan aktif',
            'new-invoice': 'Invois baru',
            'order-id': 'ID Invois',
            'payment-amount': 'Jumlah pembayaran'
        },
        'continue': 'Teruskan',
        'payout': {
            'address': 'Alamat pengeluaran dalam {currency}',
            'tag-or-memo': 'TAG atau MEMO',
            'status': {
                'processed': 'Berjaya',
                'error': 'Ralat',
                'orphan': 'Transaksi yatim',
                'approve_rejected': 'Ditolak',
                'in-progress': 'Sedang diproses',
                'need-approve': 'Perlu Kelulusan',
                'awaiting-confirmation': 'Permintaan pengeluaran anda sedang menunggu pengesahan'
            },
            'info': {
                'withdraw-id': 'ID Pengeluaran',
                'tx-hash': 'TX hash',
                'currency-and-network': 'Mata wang dan rangkaian',
                'address': 'Alamat',
                'tag-or-memo': 'TAG atau MEMO',
                'amount': 'Jumlah pengeluaran'
            }
        },
        'fiat': {
            'title': 'Deposit melalui fiat',
            'info': {
                'amount': 'Jumlah',
                'date': 'Tarikh pembayaran',
                'id': 'ID Deposit',
                'system': 'Sistem pembayaran'
            },
            'status': {
                'new': 'Baru',
                'pending': 'Tertunda',
                'authorized': 'Dibenarkan',
                'confirmed': 'Disahkan',
                'reconciled': 'Diselaraskan',
                'error': 'Ralat',
                'declined': 'Ditolak'
            }
        }
    },
    'errors': {
        'wrong-widget-id': 'ID widget salah',
        'wrong-ext-user-id': 'ID pengguna luaran salah',
        '404': 'Oops! Kami mencari tetapi tidak menemui apa yang anda cari.',
        'without-xt-user-id-withdrawal': 'Pengeluaran tidak tersedia. Parameter extUserId tidak diberikan',
        'without-xt-user-id-deposit': 'Deposit tidak tersedia. Parameter extUserId tidak diberikan'
    },
    'invoice': {
        'order': 'Pesanan',
        'inputs': {
            'email': {
                'label': 'Alamat e-mel',
                'placeholder': 'Masukkan alamat e-mel anda'
            },
            'amount': {
                'label': 'Jumlah',
                'placeholder': 'Masukkan jumlah'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'Jumlah dalam',
                'rate': 'Kadar pertukaran',
                'payment-id': 'ID Pembayaran',
                'description': 'Deskripsi'
            }
        },
        'order-public-link': {
            'do-not-refresh': 'Jangan muat semula halaman atau buka invois dalam',
            'new-tab': 'tab baru'
        },
        'statuses': {
            'ERROR': 'RALAT',
            'PENDING': 'TERTUNDA',
            'PROCESSED': 'DIPROSES',
            'REJECTED': 'DITOLAK',
            'OVERPAID': 'TERLEBIH BAYAR',
            'CREATED': 'DICIPTA',
            'PARTIAL': 'SEBAHAGIAN DIBAYAR',
            'INIT': 'INISIASI',
            'EXPIRED': 'TAMAT'
        }
    },
    'personal': {
        'titles': {
            'deposit': 'Deposit',
            'payment-history': 'Sejarah pembayaran'
        },
        'payment-history': {
            'empty-label': 'Semua transaksi anda yang dihantar ke alamat yang dinyatakan akan tersedia di sini',
            'headers': {
                'date': 'Tarikh dan Masa',
                'amount': 'Jumlah',
                'tx': 'Tx_hash',
                'status': 'Status'
            },
            'statuses': {
                'processed': 'Diproses',
                'pending': 'Tertunda',
                'rejected': 'Ditolak',
                'error': 'Ralat'
            },
            'in': 'dalam'
        },
        'qr-block': {
            'empty-label': 'Penambahan dengan mata wang kripto',
            'qr-info-pre-invoice': 'Hantar hanya',
            'qr-info-pre-personal': 'Hantar sebarang jumlah hanya kepada',
            'qr-info-post': 'ke alamat ini',
            'qr-info-minimal': 'Pemindahan kurang daripada 1 USD tidak dikreditkan'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'Deposit melalui fiat',
            'payment-history': 'Sejarah pembayaran'
        },
        'labels': {
            'pay': 'Bayar',
            'service-commission': 'Jumlah komisen perkhidmatan',
            'total': 'Jumlah keseluruhan',
            'you-pay': 'Anda bayar'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'Transaksi yatim',
            'info': 'Salah satu transaksi pada pesanan ini mengandungi rangkaian atau mata wang yang salah.',
            'support': 'Hubungi sokongan teknikal dengan ID: '
        }
    },
    'cookie-policy': {
        'by-clicking': 'Dengan mengklik butang "Teruskan", anda secara automatik bersetuju dengan',
        'our': 'dasar kuki kami'
    },
    'payout': {
        'payout': 'Pembayaran',
        'output': 'Pengeluaran',
        'withdraw': 'Pengeluaran',
        'errors': {
            'wrong-address': 'Alamat tidak berada di rangkaian {network}'
        }
    }
}
